import { render } from "./Divisions.vue?vue&type=template&id=7267bae4&scoped=true"
import script from "./Divisions.vue?vue&type=script&lang=js"
export * from "./Divisions.vue?vue&type=script&lang=js"

import "./Divisions.vue?vue&type=style&index=0&id=7267bae4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7267bae4"

export default script